import React from "react";
import { Input } from "../../ui/Input";

export const ChurchBodiesForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {
    return (
        <>
            <Input
                label={"Full Name"}
                name={"uboFullName"}
                value={formData.uboFullName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input
                label={"Address"}
                name={"uboAddress"}
                value={formData.uboAddress}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input 
                label={"Nature/Purpose"}
                name={"uboNature"}
                value={formData.uboNature}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input 
                label={"Names of Classes of Beneficiaries"}
                name={"uboClasses"}
                value={formData.uboClasses}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input 
                label={"Chairman of the Board of Trustees"}
                name={"uboChairman"}
                value={formData.uboChairman}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />
        </>
    );
})